module.exports = __webpack_public_path__ + "static/img/h5_open_app.9e34ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h5_open_app.png
// module id = 9DA8
// module chunks = 1